import { createFileRoute, useParams } from "@tanstack/react-router";
import { z } from "zod";
import { UserDetailPage } from "@/components/crud/UserDetailPage";

export const Route = createFileRoute("/admin/_layout/reports_/$userId")({
  validateSearch: z.object({ tab: z.string().optional().catch(undefined) }),
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = useParams({
    from: "/admin/_layout/reports_/$userId",
  });
  const { tab } = Route.useSearch();
  return (
    <UserDetailPage
      userId={userId}
      activeTab={tab}
      defaultTab="timesheets"
    />
  );
}
